import React, { FC, MouseEventHandler } from 'react';

import classNames from 'classnames';

import './MaterialIcon.scss';

type Props = {
    readonly icon: string;
    readonly primary?: boolean;
    readonly className?: string;
    readonly onClick?: MouseEventHandler<HTMLElement> | undefined;
};

const MaterialIcon: FC<Props> = ({ icon, primary, onClick, className }) => {
    return (
        <i
            className={classNames(
                className,
                'material-icon',
                primary && 'material-icon--primary',
                onClick && 'material-icon--clickable'
            )}
            onClick={onClick}
        >
            {icon}
        </i>
    );
};

export default MaterialIcon;
